import { CATEGORY_OPTIONS, DIVISION_CODES } from '@config/constant';
import { ToastType, useTosterStore } from '@store/toster';
import { ReactElement, useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';

const supportUrl = process.env.REACT_SUPPORT_API_URL;
const appUrl = process.env.REACT_APP_URL;

export const HelpAndSupport = (): ReactElement => {
	const [formData, setFormData] = useState({
		category: '',
		subcategory: '',
		cmdiCode: '',
		divisionCode: '',
		email: '',
		subject: '',
		description: '',
		subcategoryOptions: [] as string[],
	});
	const formRef = useRef<HTMLFormElement>(null);
	const { setToaster } = useTosterStore();

	const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>): void => {
		const { name, value } = event.target;
		setFormData((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const onCategoryChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
		const selectedCategory = event.target.value;
		setFormData((prevState) => ({
			...prevState,
			category: selectedCategory,
			subcategory: '',
			subcategoryOptions: CATEGORY_OPTIONS[selectedCategory as keyof typeof CATEGORY_OPTIONS] || [],
		}));
	};

	const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
		event.preventDefault();

		const { category, subcategory, cmdiCode, divisionCode, email, subject, description } = formData;

		if (!category || !subcategory || !cmdiCode || !divisionCode || !email || !subject || !description) {
			setToaster(true, ToastType.error, 'Please fill out all required fields.');
			return;
		}

		if (formRef.current) {
			formRef.current.submit();
		}
	};

	return (
		<section className="help-support-section">
			<div className="help-support-content-wrapper">
				<span className="h3">To resolve issue with User Transfer and Meetings, use this Self Service form.</span>
				<div className="support-email-id support-email-id-custom">
					<NavLink
						to="https://forms.office.com/r/FWCFwMpGdr"
						aria-label="Support Form"
						target="_blank"
						rel="noopener noreferrer"
					>
						Click here to fill out the form
					</NavLink>
				</div>
				<div className="cmn-heading">
					<span>Or</span>
				</div>
				<p className="h3">Fill this form to report Mpower Issues</p>
				<div className="support-wrapper">
					<form ref={formRef} action={supportUrl} method="POST" onSubmit={handleSubmit}>
						<input type="hidden" name="orgid" value="00D2v000000S7Ef" />
						<input type="hidden" name="retURL" value={appUrl} />
						<input type="hidden" id="00N5i00000H3WRU" name="00N5i00000H3WRU" value="Mpower" />
						<input type="hidden" id="priority" name="priority" value="Medium" />

						<label htmlFor="cmdiCode">CMDI Code</label>
						<input
							id="cmdiCode"
							name="cmdiCode"
							type="text"
							value={formData.cmdiCode}
							onChange={handleChange}
							required
						/>

						<label htmlFor="divisionCode">Division Code</label>
						<select
							id="divisionCode"
							name="divisionCode"
							value={formData.divisionCode}
							onChange={handleChange}
							required
						>
							<option value="">--Select Division Code--</option>
							{DIVISION_CODES.map((division) => (
								<option key={division} value={division}>
									{division}
								</option>
							))}
						</select>

						<label htmlFor="email">Email</label>
						<input id="email" name="email" type="email" value={formData.email} onChange={handleChange} required />

						<label htmlFor="category">Category</label>
						<select id="category" name="category" value={formData.category} onChange={onCategoryChange} required>
							<option value="">--Select Category--</option>
							{Object.keys(CATEGORY_OPTIONS).map((cat) => (
								<option key={cat} value={cat}>
									{cat}
								</option>
							))}
						</select>

						<label htmlFor="subcategory">Subcategory</label>
						<select id="subcategory" name="subcategory" value={formData.subcategory} onChange={handleChange} required>
							<option value="">--Select Subcategory--</option>
							{formData.subcategoryOptions.map((sub) => (
								<option key={sub} value={sub}>
									{sub}
								</option>
							))}
						</select>

						<label htmlFor="subject">Subject</label>
						<input id="subject" name="subject" type="text" value={formData.subject} onChange={handleChange} required />

						<label htmlFor="description">Description</label>
						<textarea
							id="description"
							name="description"
							value={formData.description}
							onChange={handleChange}
							required
						/>

						<input type="submit" className="support-submit-btn" value="Submit" />
					</form>
				</div>
				<div className="cmn-heading">
					<span>Or</span>
				</div>
				<span className="h3">Write to us at</span>
				<div className="custom-email-btn">
					<NavLink to="mailto:mpowersupport@pidilite.com" aria-label="support email">
						mpowersupport@pidilite.com
					</NavLink>
				</div>
				<div className="cmn-heading">
					<span>Or</span>
				</div>
				<span className="h3">Contact us on MyPidilite Helpline</span>

				<div className="custom-email-btn">
					<NavLink to="mailto:mpowersupport@pidilite.com" aria-label="support email">
						mpowersupport@pidilite.com
					</NavLink>
				</div>
				<div className="contact-list">
					<div className="support-contact">
						<NavLink to="tel:+18002667789" aria-label="support contact">
							<span className="icon-call icons" />
							<span className="content">18002667789</span>
						</NavLink>
					</div>
					<div className="support-contact">
						<NavLink to="tel:+918828123538" aria-label="support contact">
							<span className="icon-call icons" />
							<span className="content">8828123538</span>
						</NavLink>
					</div>
				</div>
			</div>
		</section>
	);
};
